/* TTS Edit product page (templates/product.edit.json) - 2026-09
   1. Condition dialog: buttons with data-tts-edit-open="<dialog id>" open a native <dialog>,
      [data-tts-edit-close] and a click on the backdrop close it. Focus returns to the opener.
   2. Desktop gallery: caption under each tile from the image alt text (data from snippets/tts-edit-media.liquid)
      and an "N photos" pill on the first photo. */
(function () {
  'use strict';

  function openDialog(dialog, opener) {
    if (!dialog) return;
    dialog._ttsOpener = opener || null;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    var closeBtn = dialog.querySelector('[data-tts-edit-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      if (dialog._ttsOpener) dialog._ttsOpener.focus();
    }
  }

  function bindDialogs() {
    if (window.ttsEditDialogsBound) return;
    window.ttsEditDialogsBound = true;

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-tts-edit-open]');
      if (opener) {
        event.preventDefault();
        openDialog(document.getElementById(opener.getAttribute('data-tts-edit-open')), opener);
        return;
      }
      var closer = event.target.closest('[data-tts-edit-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }
      /* click on the backdrop: the target is the dialog element itself */
      if (event.target.matches && event.target.matches('dialog.tts-edit-dialog')) {
        var rect = event.target.getBoundingClientRect();
        var inside = event.clientX >= rect.left && event.clientX <= rect.right &&
          event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) closeDialog(event.target);
      }
    });

    document.addEventListener('close', function (event) {
      var dialog = event.target;
      if (dialog && dialog.matches && dialog.matches('dialog.tts-edit-dialog') && dialog._ttsOpener) {
        dialog._ttsOpener.focus();
      }
    }, true);

    /* fallback for browsers without <dialog>: Escape closes */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector('dialog.tts-edit-dialog[open]');
      if (open && typeof open.showModal !== 'function') closeDialog(open);
    });
  }

  function captionText(alt) {
    var parts = String(alt).split(': ');
    var text = parts[parts.length - 1].trim();
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function decorateGallery(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('script[data-tts-edit-media]');
    Array.prototype.forEach.call(nodes, function (node) {
      var data;
      try {
        data = JSON.parse(node.textContent);
      } catch (e) {
        return;
      }
      var sectionId = node.getAttribute('data-tts-edit-media');
      var gallery = document.getElementById('MediaGallery-' + sectionId) || document.querySelector('.main-product__media');
      if (!gallery) return;
      var grid = gallery.querySelector('.main-product__media--grid');
      if (!grid) return;

      var items = grid.querySelectorAll('.main-product__media--grid-item');
      Array.prototype.forEach.call(items, function (item, index) {
        var slide = item.querySelector('[data-media-id]');
        if (!slide) return;
        var id = slide.getAttribute('data-media-id');
        var alt = data.captions && data.captions[id];
        if (alt && !item.querySelector('.tts-edit-caption')) {
          var text = captionText(alt);
          if (text) {
            var caption = document.createElement('p');
            caption.className = 'tts-edit-caption';
            caption.setAttribute('aria-hidden', 'true'); /* the image alt already says it */
            caption.textContent = text;
            item.appendChild(caption);
          }
        }
        if (index === 0 && data.count >= 3 && data.countLabel && !item.querySelector('.tts-edit-count')) {
          var pill = document.createElement('span');
          pill.className = 'tts-edit-count';
          pill.textContent = data.countLabel;
          slide.appendChild(pill);
        }
      });
    });
  }

  function init() {
    bindDialogs();
    decorateGallery(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    decorateGallery(event.target);
    decorateGallery(document);
  });
})();
